var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.624 5.088C14.5813 5.00267 14.528 4.928 14.464 4.864L9.792 0.192001C9.664 0.0640005 9.51467 0 9.344 0H0.672C0.48 0 0.32 0.0640005 0.192 0.192001C0.0639999 0.320001 0 0.480001 0 0.672001V19.36C0 19.5307 0.0639999 19.68 0.192 19.808C0.341333 19.936 0.501333 20 0.672 20H13.984C14.1547 20 14.304 19.936 14.432 19.808C14.5813 19.68 14.656 19.5307 14.656 19.36V5.344C14.656 5.25867 14.6453 5.17333 14.624 5.088ZM9.984 2.272L12.384 4.672H9.984V2.272ZM1.344 18.688V1.344H8.672V5.344C8.672 5.536 8.736 5.696 8.864 5.824C8.992 5.952 9.152 6.016 9.344 6.016H13.344V18.688H1.344Z",
    fill: "#53565A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.ad0541624d1a9bb09f96d04a2229ecfe.svg";
export { ForwardRef as ReactComponent };